export default "__VITE_ASSET__zsMCfzQs__"